import {
  AnalysTypeEnum,
  DetaljStatusEnum,
} from '../../Const/EkonomiskAnalysConsts';
import EDBox from '../../../../../../../BaseComponents/EDBox/EDBox';
import { useTheme } from '@mui/material/styles';
import { shouldHaveGreenValue } from '../../Utils/detaljanalysUtils';

interface IProps {
  analysType: AnalysTypeEnum;
  avvikelseBudgetRiktvarde: number;
  isKostnadInIntaktUppfoljning?: boolean;
  status: DetaljStatusEnum;
}

export const SammanfattningStatus = (props: IProps) => {
  const theme = useTheme();

  const getStatusColor = (
    status: DetaljStatusEnum,
    analysType: AnalysTypeEnum,
    avvikelseBudgetRiktvarde: number,
    isKostnadInIntaktUppfoljning?: boolean
  ) => {
    switch (status) {
      case DetaljStatusEnum.ABOVE:
        if (
          shouldHaveGreenValue(
            avvikelseBudgetRiktvarde,
            analysType,
            isKostnadInIntaktUppfoljning
          )
        ) {
          //Green color
          return theme.customProperties.AktivitetColors.begravning;
        } else {
          //Salmon color
          return theme.customProperties.AktivitetColors.snabbokning;
        }
      case DetaljStatusEnum.BELOW:
        if (
          shouldHaveGreenValue(
            avvikelseBudgetRiktvarde,
            analysType,
            isKostnadInIntaktUppfoljning
          )
        ) {
          //Green color
          return theme.customProperties.AktivitetColors.begravning;
        } else {
          //Salmon color
          return theme.customProperties.AktivitetColors.snabbokning;
        }
      case DetaljStatusEnum.EQUAL:
        return theme.customProperties.Legend.orange.faded;
    }
  };

  const getStatusText = (status: DetaljStatusEnum) => {
    switch (status) {
      case DetaljStatusEnum.ABOVE:
        return 'Över budget';
      case DetaljStatusEnum.BELOW:
        return 'Under budget';
      case DetaljStatusEnum.EQUAL:
        return 'I linje med budget';
    }
  };

  return (
    <EDBox
      component={'span'}
      sx={theme => ({
        backgroundColor: getStatusColor(
          props.status,
          props.analysType,
          props.avvikelseBudgetRiktvarde,
          props.isKostnadInIntaktUppfoljning
        ),
        color: theme.palette.common.black,
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
        borderRadius: '8px',
        display: 'inline-block',
        minWidth: '125px',
        textAlign: 'center',
      })}
    >
      {getStatusText(props.status)}
    </EDBox>
  );
};
